import actionTypes from '../../action-types'

export default (id) => ({
  type: actionTypes.ADMINISTRATORS.FETCH,
  payload: {
    id,
  },
})
